<div
  class="pl-dialog-overlay"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId"
  [attr.aria-describedby]="contentId"
>
  <div class="heading">
    <h2 [id]="titleId">{{ config.title }}</h2>
  </div>

  <div class="content" [id]="contentId">
    {{ config.content }}
  </div>

  <div class="actions">
    <button
      #primaryButton
      mat-flat-button
      color="primary"
      type="button"
      (click)="onButtonClick()"
    >
      {{ config.buttonLabel }}
    </button>
  </div>
</div>
